import React, { useContext } from 'react'
import { useTranslation, withTranslation } from 'react-i18next';
import StateContext from '../../../StateContext';
import { get_lang } from '../../../Functions/getLang';
import paidIcon from "../../../Assets/images/paidIcon.svg";
import "./OrderDetails.scss";
import { Button } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import axios from 'axios';
import { formatMoney } from '../../../helper/customeObj';

// Function to convert 24-hour time to 12-hour format
const formatTimeTo12Hour = (time24) => {
  if (!time24) return '';
  
  const [hours, minutes] = time24.split(':');
  const hour = parseInt(hours, 10);
  const minute = parseInt(minutes, 10);
  
  const period = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  
  return `${hour12}:${minute.toString().padStart(2, '0')} ${period}`;
};

// Function to format date by removing time portion
const formatDateOnly = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  // Split by space and take only the date part (before the space)
  return dateTimeString.split(' ')[0];
};

const handleIArrived = (arrival_code) => {
  let url = `${process.env.REACT_APP_API_URL}order_invoice/pickup/arrived?arrival_code=${arrival_code}&arrived_by=2`
  axios.post(url).then(response => {
  }).catch(error => {
  })
}

const OrderDetails = ({ invoiceDetails }) => {
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const { invoiceable } = invoiceDetails;
  const currencyCode =
    invoiceDetails?.business?.currency ||
    appState?.storeInfo?.currencyCode ||
    "KWD";
  const money = (value) =>
    formatMoney(value, currencyCode, appState?.langValue);
  return (
    <div id="invoice_details" className="invoice_details col-12">
      <div className="row m-0  justify-content-between aling-items-center ">
        <div className=" col-12 px-0 d-flex justify-content-between align-items-center " >
          <h5 className="px-0 my-4 familyPoppins600">
            {t("OrderStatus.Order-Details")}
          </h5>
          <img
            src={invoiceDetails.business ? invoiceDetails.business.logo : ""}
            alt=""
            className="img-fluid"
            style={{ borderRadius: "20%", height: "80px", width: "80px", objectFit: 'contain !important' }}
          />
        </div>
     {(invoiceable?.info?.arrived_at == null && invoiceable?.info?.arrival_code != null) && 
     <div className="col-12 px-0 my-3 my-md-4">
          <div className="arrived-notification-card">
            <div className="arrived-card-content">
              <div className="arrived-info-section" >
                <div className="arrived-icon-badge">
                  <NotificationsActiveIcon sx={{ color: '#fff', fontSize: '20px' }} />
                </div>
                <div className="arrived-text-content" style={{direction:  appState.langValue == 'ar' ? 'rtl' : 'ltr'}}>
                  <h6 className="arrived-title">
                    {t("Pickup Notification", "Pickup Notification")}
                  </h6>
                  <p className="arrived-description  " style={{border: 'none', textAlign: 'left'}}>
                    {t("arrived-btn-description", "Press the button once you arrived")}
                  </p>
                </div>
              </div>
              <Button
                variant="contained"
                onClick={() => {
                  window.open(`${process.env.REACT_APP_API_URL}order_invoice/pickup/arrived?arrival_code=${invoiceable?.info?.arrival_code}&arrived_by=2`, '_blank');
                }}
                className="arrived-btn"
                sx={{
                  background: 'linear-gradient(135deg, #eb5b5e 0%, #d32f2f 100%)',
                  borderRadius: '12px',
                  padding: { xs: '14px 24px', sm: '12px 28px' },
                  fontSize: { xs: '14px', sm: '15px' },
                  fontWeight: 700,
                  textTransform: 'none',
                  boxShadow: '0 4px 15px rgba(235, 91, 94, 0.4)',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  letterSpacing: '0.3px',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #d32f2f 0%, #eb5b5e 100%)',
                    boxShadow: '0 6px 25px rgba(235, 91, 94, 0.5)',
                    transform: 'translateY(-2px) scale(1.02)',
                  },
                  '&:active': {
                    transform: 'translateY(0px) scale(0.98)',
                  },
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  width: { xs: '100%', sm: 'auto' },
                  minWidth: { xs: '100%', sm: '180px' },
                  justifyContent: 'center',
                  whiteSpace: 'nowrap',
                }}
              >
                <LocationOnIcon sx={{ fontSize: { xs: '18px', sm: '20px' } }} />
                <span>{t("I Have Arrived")}</span>
              </Button>
            </div>
          </div>
        </div>}
        <div className=" col-12 d-flex justify-content-between  px-1 text-secondary orderPaymentsDetails"  >
          <h6 className=" mt-2  familysora400">{t("OrderStatus.Invoice-No")}</h6>
          <h6 className="familysora600 mt-2  "># {invoiceDetails.id} </h6>
        </div>
        {(appState?.storeInfo?.business_name !=null || undefined) && <div className="col-12  d-flex justify-content-between  px-1 orderPaymentsDetails">
          <h6 className=" mt-2  familysora400">{t("invoice.store-name")}</h6>
          <h6 className="familysora600 mt-2 ">{appState?.storeInfo?.business_name} </h6>
        </div>}

        {(invoiceable?.branch.name !=null || undefined ) && <div className="col-12  d-flex justify-content-between  px-1 orderPaymentsDetails">
          <h6 className=" mt-2  familysora400">{t("OrderStatus.branch")}</h6>
          <h6 className="familysora600 mt-2 ">{invoiceable?.branch.name
            ? get_lang(invoiceable?.branch.name, appState.langValue)
            : ""} </h6>
        </div>}

        {invoiceDetails.is_paid && invoiceDetails.paid.date ? (
          <div className="col-12  d-flex justify-content-between  px-1 orderPaymentsDetails">
            <h6 className=" mt-2  familysora400">{t("OrderStatus.Date")}</h6>
            <h6 className="familysora600 mt-2 ">{invoiceDetails.paid.date} </h6>
          </div>
        ) : invoiceDetails.failed.date != null ? (
          <div className="col-12 d-flex justify-content-between  px-1 ">
            <h6 className=" mt-2  familysora400">{t("OrderStatus.Date")}</h6>
            <h6 className="familysora600 mt-2 ">
              {" "}
              {invoiceDetails.failed.date != null
                ? invoiceDetails.failed.date
                : ""}{" "}
            </h6>
          </div>
        ) : (
          ''
        )}

        {invoiceDetails.is_paid && invoiceDetails.paid.time ? (
          <div className=" col-12 d-flex justify-content-between  px-1">
            <h6 className=" mt-2  familysora400">{t("Order Time")}</h6>
            <h6 className="familysora600 mt-2 ">{invoiceDetails.paid.time}</h6>
          </div>
        ) : invoiceDetails.failed.time != null ? (
          <div className="col-12 d-flex justify-content-between  px-1">
            <h6 className=" mt-2  familysora400">{t("Order Time")}</h6>
            <h6 className="familysora600">
              {invoiceDetails.failed.time != null
                ? invoiceDetails.failed.time
                : ""}
            </h6>
          </div>
        ) : (
          <div className="col-12 d-flex justify-content-between  px-1">
            <h6 className=" mt-2  familysora400">{t("Order Time")}</h6>
            <h6 className="familysora600 mt-2 ">
              {" "}
              {invoiceDetails.updated_at != null
                ? invoiceDetails.updated_at
                : ""}{" "}
            </h6>
          </div>
        )}

        {
          invoiceable?.info?.arrived_at != null && <div className="col-12 d-flex justify-content-between  px-1">
          <h6 className=" mt-2  familysora400">{t("Arrived At")}</h6>
          <h6 className="familysora600 mt-2 ">
            { invoiceable?.info?.arrived_at } 
          </h6>
        </div> 
        }

        {invoiceable?.service_type == "Delivery" && <div className="col-12 d-flex justify-content-between  px-1">
            <h6 className=" mt-2  familysora400">{t("Delivery Date")}</h6>
            <h6 className="familysora600 mt-2 ">
              { invoiceable?.info?.delivery_time_slot !== null ? formatDateOnly(invoiceable?.info?.delivery_date) : invoiceable?.info?.delivery_date}
            </h6>
          </div> 
          }
          
          {invoiceable?.service_type == "Delivery" && <div className="col-12 d-flex justify-content-between  px-1">
            <h6 className=" mt-2  familysora400">{t("Delivery Time")}</h6>
            <h6 className="familysora600 mt-2 ">
              {invoiceable?.info?.delivery_time_slot !== null ? 
                `${formatTimeTo12Hour(invoiceable?.info?.delivery_time_slot?.starting_time)} - ${formatTimeTo12Hour(invoiceable?.info?.delivery_time_slot?.ending_time)}` 
                : "ASAP"}
            </h6>
          </div> 
          }

        {invoiceDetails.transaction ? (
          invoiceDetails.transaction.failed_at.date ? (

            <div className="col-12 d-flex justify-content-between  px-1">
              <h6 className=" mt-2  familysora400">{t("OrderStatus.Date")}</h6>
              <h6 className="familysora600 mt-2 ">
                {" "}
                {invoiceDetails.transaction.failed_at.date}{" "}
              </h6>
            </div>
          ) : (
            ""
          )
        ) : (
          ""
        )}

        {invoiceDetails.transaction ? (
          invoiceDetails.transaction.failed_at.time ? (
            <div className="col-12 d-flex justify-content-between  px-1">
              <h6 className=" mt-2  familysora400">{t("OrderStatus.Time")}</h6>
              <h6 className="familysora600 mt-2 ">
                {" "}
                {invoiceDetails.transaction.failed_at.time}
              </h6>
            </div>
          ) : (
            ""
          )
        ) : (
          ""
        )}

        {invoiceDetails.status != "Pending" ?
          <div className="col-12  d-flex justify-content-between align-items-center px-1">
            <h6 className=" mt-2  familysora400">
              {t("OrderStatus.Payment-Method")}
            </h6>
            <h6 className="familysora600 mt-2 ">
              <span style={{ color: 'green', fontSize: '12px' }}>{t("OrderStatus.Paid")} &nbsp;</span>
              <span style={{ color: 'green', fontSize: '12px' }}>   <img
                src={paidIcon}
              /> &nbsp;</span>
              {invoiceDetails.status == "Direct"
                ? "IN STORE"
                : invoiceDetails.is_partial ||
                  invoiceDetails.status == "Partial" ||
                  invoiceDetails.payment_method === "PARTIAL"
                  ? t("invoice.Split")
                  : invoiceDetails.transaction
                    ? invoiceDetails.transaction.payment_source
                    : ""}
            </h6>
          </div>
        :  
        <div className="col-12  d-flex justify-content-between align-items-center px-1">
        <h6 className=" mt-2  familysora400">
          {t("OrderStatus.Payment-Method")}
        </h6>
        <h6 className="familysora600 mt-2 ">
          <span style={{ color: 'orange', fontSize: '12px' }}>{t("OrderStatus.Pending")} &nbsp;</span>
          <span style={{ color: 'orange', fontSize: '12px' }}>  !
             {/* <img
            src={canceIcon}
          /> &nbsp; */}
          </span>
          {invoiceDetails.status == "Direct"
            ? "IN STORE"
            : invoiceDetails.is_partial ||
              invoiceDetails.status == "Partial" ||
              invoiceDetails.payment_method === "PARTIAL"
              ? t("invoice.Split")
              : invoiceDetails.transaction
                ? invoiceDetails.transaction.payment_source
                : ""}
        </h6>
      </div>
        }


        {invoiceable.tip > 0 &&
          <div className="col-12 d-flex justify-content-between  px-1 waiterTip" >
            <h6 className=" mt-2  familysora400">
              {t("OrderStatus.Waiter-Tip")}

            </h6>
            <h6 className="familysora600 mt-2 "  >
              {" "}
              {money(invoiceable.tip)}
            </h6>
          </div>}
        {invoiceable.discounted_amount > 0 &&
          <div className="col-12 d-flex justify-content-between  px-1 " >
            <h6 className=" mt-2  familysora400">
              {t("OrderStatus.discount-amount")}

            </h6>
            <h6 className="familysora600 mt-2 "  >
              {" "}
              {money(invoiceable.discounted_amount)}
            </h6>

          </div>}

          {invoiceable?.info?.is_gift && 
          <>
          <div className=" col-12 d-flex justify-content-between  px-1 text-secondary orderPaymentsDetails">
            <h6 className=" mt-2  familysora400">{t("Gifting Info")}:</h6>
            <h6 className="familysora600 mt-2  "></h6>
          </div>
              {[{name: t('Massage'), value: invoiceable?.info?.gift?.message}, 
                {name: t('Receiver Name'), value: invoiceable?.info?.gift?.name}, 
                {name: t('Receiver Phone'), value: invoiceable?.info?.gift?.number ?
                  `+ ${invoiceable?.info?.gift?.country_code} ${invoiceable?.info?.gift?.number}` : ""}, 
                {name: t('Call Recipient'), value: invoiceable?.info?.gift?.call_recipient ? 'Yes' : 'No'}].map((info, i) => {
                return info.value && (
                  <div className=" col-12 d-flex justify-content-between px-1 ">
                    <h6 className=" mt-2  familysora400">{info.name}:</h6>
                    <h6 className="familysora600 mt-2  ">{info.value}</h6>
                  </div>
                )
              })}
          
          </>}


        {invoiceDetails.type !== "QuickInvoice" && (
          <h5 className="px-0 mt-4 familyPoppins600">
            {t("OrderStatus.Your-Order")}
          </h5>
        )}
      </div>

      {invoiceDetails.type !== "QuickInvoice" && (
        <ul className=" col-12  px-0 mx-0 mb-1">
          {invoiceable.orders.length > 0 &&
            invoiceable.orders.map((order, i) => {
              // console.log("invoiceable.orders",invoiceable.orders)
              return (
                <li key={i}>
                  <span className=" text-capitalize mt-2  d-flex align-item-center justify-content-between">
                    <span className="familysora400">
                      {" "}
                      {order.product.name
                        ? get_lang(order.product.name, appState.langValue)
                        : ""}{" "}
                    </span>
                    <span className="familysora600">
                      {" "}
                      {order.price ? money(order.price) : ""} 
                    </span>
                  </span>
                  {order.addons.map((addon, i) => {
                    return (
                      <span
                        key={i}
                        className="orderText  d-flex align-item-center justify-content-between"
                      >
                        <span className="familysora400">
                          {addon.product_addon.addon
                            ? addon.product_addon.addon.name
                              ? get_lang(
                                addon.product_addon.addon.name,
                                appState.langValue
                              )
                              : ""
                            : ""}
                        </span>
                        {addon.price > 0 && <span className="orderText  familysora600  ">
                          {" "}
                          {addon.price ? money(addon.price) : ""} 
                        </span>}
                      </span>
                    );
                  })}
                  {(order.personalizations || []).map((pers, j) => {
                    const persName = pers?.product_personalization?.name
                      ? get_lang(pers.product_personalization.name, appState.langValue)
                      : "";
                    const persTotal = Number(pers?.total ?? pers?.price);
                    return (
                      <span
                        key={`pers-${j}`}
                        className="orderText d-flex align-item-center justify-content-between"
                      >
                        <span className="familysora400">
                          {persName}
                          {pers?.text ? (
                            <span className="d-block">{pers.text}</span>
                          ) : null}
                        </span>
                        {persTotal > 0 && (
                          <span className="orderText familysora600">
                            {money(persTotal)}
                          </span>
                        )}
                      </span>
                    );
                  })}
                </li>
              );
            })}
        </ul>
      )}



      {invoiceable.combos.length > 0 && ( 
        <div className="col-12 x mb-1">
          <h6 className=" m-0 mt-2 ">combos</h6>
          <ul className="px-0 mx-0">
            {invoiceable.combos.length > 0 &&
              invoiceable.combos.map((combo, i) => {
                // console.log("invoiceable.combos",invoiceable.combos)
                return (
                  <li key={i}>
                    <span className=" text-capitalize mt-2  d-flex align-item-center justify-content-between">
                      <span className="familysora400">
                        {" "}
                        {get_lang(
                          combo.combo?.name,
                          appState.langValue
                        )}

                      </span>
                      <span className="familysora600">
                        {combo?.amount > 0 ? money(combo.amount) : "free"}
                      </span>
                    </span>

                  </li>
                );
              })}
          </ul>
        </div>
      )}


    </div>
  )
}
export default withTranslation()(OrderDetails);
